import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { IFinalResponse } from '_core/types';
import { GeoLocationTypes } from '../Types';

const machine = Machines.onGetGeoLocation.machine;

export const getGeoLocation = (
  params: GeoLocationTypes.GeoLocationServiceRequestType,
): Promise<IFinalResponse> => {
  return callServiceMachine(machine, params);
};

export default { getGeoLocation };
